const SUBTLE_ALGORITHM_SHA_256 = "SHA-256";
const HEX_RADIX = 16;
const HEX_PAIR_WIDTH = 2;

function bufferToHex(buffer: ArrayBuffer): string {
  return Array.from(new Uint8Array(buffer))
    .map((byte) => byte.toString(HEX_RADIX).padStart(HEX_PAIR_WIDTH, "0"))
    .join("");
}

/** Returns `undefined` for nullish / empty-after-trim inputs. */
export default async function hashAdvancedMatchingField(value: string | null | undefined): Promise<string | undefined> {
  if (value === null || value === undefined) {
    return undefined;
  }
  const normalized = value.trim().toLowerCase();
  if (normalized === "") {
    return undefined;
  }
  const encoded = new TextEncoder().encode(normalized);
  const digest = await crypto.subtle.digest(SUBTLE_ALGORITHM_SHA_256, encoded);
  return bufferToHex(digest);
}
